var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import styled from 'styled-components';
import AlmeDropdown from './AlmeDropdown/AlmeDropdown';
import * as Constants from './AlmeInlineConstants';
import Button from 'syf-component-library/ui/atoms/Button';
import InlineDatepicker from './Datepicker/InlineDatepicker';
import { formatdate, parseDate } from '../AlmeUtilities/dateutils';
import MultiSelectAccount from './MultiSelectAccount/MultiSelectAccount';
import { DialogButton } from '../AlmeDialog/ModalDialog';
import LaunchAutoSearchDialogue from '../AutoSearch/LaunchAutoSearchDialogue';
const FormWrapper = styled.div `
    width: 100%;
    margin-top: 10px;
`;
const ButtonWrapper = styled.div `
    margin-top: 15px;
    padding-left: 3px;
    display: flex;
    > button:last-child {
        margin-left: 5px;
    }
`;
const StyledButtonDatePicker = styled(Button) `       
   min-width: 273px;
   max-height:30px;   
`;
const StyledDatePicker = styled.div `
max-height: 48px;
&:focus-within {
    border-radius: 5px;
    box-shadow: 0 0 0 2px 
    ${({ theme }) => (theme.field.focus)};
    overflow: hidden;
    outline: none;
}
`;
const StyledButton = styled(Button) `
  min-width: 88px;  
  max-height:32px;
  font-size: ${props => props.theme.fontSizes.promptText};
`;
function getDefaultValue(responseAction) {
    if (responseAction.Name === Constants.LAUNCHPICKERINPUT) {
        const dropdownResponseAction = responseAction;
        const initialValue = dropdownResponseAction.InitialValue;
        let defaultValue;
        if (typeof initialValue === 'number') {
            defaultValue = dropdownResponseAction.Values[initialValue];
        }
        else {
            defaultValue = dropdownResponseAction.Values.find(o => o.SubmitValue === initialValue);
        }
        return (defaultValue && defaultValue.SubmitValue) || dropdownResponseAction.Values[0].SubmitValue;
    }
    else {
        const date = responseAction.ReferenceDate;
        return (date && parseDate(date)) || null;
    }
}
function formSubmitParams(widgetSelection, endType) {
    return ({
        WidgetSelection: widgetSelection,
        endType,
    });
}
const AlmeInlineForm = (_a) => {
    var { disabled, fromHistory, isLastResponse } = _a, props = __rest(_a, ["disabled", "fromHistory", "isLastResponse"]);
    const [formValue, setFormValue] = useState(() => {
        const defaultValue = getDefaultValue(props.responseAction);
        return ({ value: defaultValue, valid: !!(defaultValue === 0 || defaultValue) });
    });
    const [isDisabled, setIsDesabled] = useState(disabled);
    const onChange = (val) => {
        setFormValue(val);
    };
    const onSubmit = () => {
        var _a;
        if (formValue.valid && !isDisabled) {
            setIsDesabled(true);
            const eventName = (_a = props.responseAction) === null || _a === void 0 ? void 0 : _a.ReturnAppEventName;
            const input = formValue.value instanceof Date ? formatdate(formValue.value) : String(formValue.value); //Convert all values to string
            const parameters = formSubmitParams(input, 'Completed');
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            props.onSubmitFormAppEvent(eventName, parameters, 'Internal');
        }
    };
    const onCancel = () => {
        var _a;
        const eventName = (_a = props.responseAction) === null || _a === void 0 ? void 0 : _a.ReturnAppEventName;
        const parameters = formSubmitParams('Aborted', 'Aborted');
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        props.onSubmitFormAppEvent(eventName, parameters, 'Internal');
    };
    return (React.createElement(FormWrapper, null,
        props.responseAction.Name === Constants.LAUNCHPICKERINPUT
            ? React.createElement(AlmeDropdown, { value: formValue.value, responseAction: props.responseAction, responseRevision: props.responseRevision, onChange: onChange, disabled: isDisabled }) : null,
        isLastResponse && !fromHistory && props.responseAction.Name === Constants.LAUNCHPICKERMULTISELECT
            ? React.createElement(MultiSelectAccount, { value: formValue.value, responseAction: props.responseAction, responseRevision: props.responseRevision, onSubmitFormAppEvent: props.onSubmitFormAppEvent, status: false, onChange: onChange, disabled: isDisabled })
            : null,
        !fromHistory && props.responseAction.Name === Constants.LAUNCHDATEPICKERINPUT
            ? React.createElement(StyledDatePicker, { tabIndex: props.tabIndex },
                React.createElement(InlineDatepicker, { value: formValue.value, responseAction: props.responseAction, responseRevision: props.responseRevision, onChange: onChange, disabled: isDisabled })) : null,
        (!isDisabled || !fromHistory) && props.responseAction.Name === Constants.LAUNCHAUTOSEARCHBOX
            ?
                React.createElement(LaunchAutoSearchDialogue, { responseAction: props.responseAction, responseRevision: props.responseRevision, onSubmitFormAppEvent: props.onSubmitFormAppEvent, tabIndex: props.tabIndex })
            : null,
        React.createElement(ButtonWrapper, null,
            props.responseAction.Name === Constants.LAUNCHDATEPICKERINPUT
                ? React.createElement(StyledButtonDatePicker, { onClick: onSubmit, buttonType: 'primary', id: `inline-form-submit-button-${props.responseRevision}`, disabled: isDisabled }, "Submit")
                : null,
            props.responseAction.Name === Constants.LAUNCHPICKERMULTISELECT
                ? React.createElement(DialogButton, { onClick: onSubmit, buttonType: 'primary', id: `alme-survey-dialog-yes-button-${props.responseRevision}`, disabled: isDisabled }, "Submit")
                : null,
            props.responseAction.Name === Constants.LAUNCHPICKERINPUT
                ? React.createElement(StyledButton, { onClick: onSubmit, buttonType: 'primary', id: `inline-form-submit-button-${props.responseRevision}`, disabled: isDisabled }, "Submit")
                : null),
        props.responseAction.Name === Constants.LAUNCHDATEPICKERINPUT
            ? React.createElement(StyledButtonDatePicker, { onClick: onCancel, buttonType: 'ghost', id: `inline-form-cancel-button-${props.responseRevision}`, disabled: isDisabled }, "Cancel")
            : null,
        props.responseAction.Name === Constants.LAUNCHPICKERMULTISELECT
            ? React.createElement(DialogButton, { onClick: onCancel, buttonType: 'ghost', id: `alme-survey-dialog-no-button-${props.responseRevision}`, disabled: isDisabled }, "Cancel")
            : null));
};
export default AlmeInlineForm;
